import cn from "classnames";
import styles from "../LeftSideMain.module.scss";
import LeftSideItem from "../../LeftSideItem/LeftSideItem";
import {useSelector} from "react-redux";
import UserProfileIcon from "../../../shared/icons/UserProfileIcon";
import LeftSideItemFooter from "../../LeftSideItem/LeftSideItemFooter";

export function LeftSideFooter({
    isExpand,
    setActiveRouteName,
    activeRouteName,
    onForceClose
}){
  const { user } = useSelector(state => state);

    const logoutItem = {
        title: user.name,
        icon: <UserProfileIcon />,
        link: '/profile',
        bin: user?.bin
    };

    return(
        <div className={cn(styles["navigation-custom__footer"],styles["pl-11"], styles['pr-11'])}>
          {/* <LeftSideItem  key='isNotify'
            item={notifyItem}
            isNotify
            displayText={isExpand}
            setActiveRouteName={setActiveRouteName}
            activeRouteName={activeRouteName}
            onForceClose={onForceClose}
            isExpand={isExpand}
          /> */}
            {/* <LeftSideItem  key='isBalance'
              item={balanceItem}
              isBalance displayText={isExpand}
              setActiveRouteName={setActiveRouteName}
              activeRouteName={activeRouteName}
              onForceClose={onForceClose}
              isExpand={isExpand}
            /> */}
            <LeftSideItemFooter key="isLogout"
              item={logoutItem}
              isLogout displayText={isExpand}
              activeRouteName={activeRouteName}
              setActiveRouteName={setActiveRouteName}
              onForceClose={onForceClose}
              isExpand={isExpand}
            />
        </div>
    )
}